import React, { Component } from "react";
import { connect } from "react-redux";
import { Image, Collapse, message, Tooltip } from "antd";

import storageUtils from "../../utils/storageUtils";
import { req_single_eps_blogger, req_edit_eps_blogger } from "../../api";

import PicturesFace from "./pictures-face";
import PicturesBanner from "./pictures-banner";
import QRCode from "react-qr-code";

import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CLIENT_URL, API_BASE, DEFAULT_IMAGE_URL } from "../../utils/contrains";

const { Panel } = Collapse;

class BloggerInformation extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    userLevel: "NORMAL",
    items: [],
    item: {},
    loading: false,
    bannerPics: null,
    facePics: null,
    copyWebUrl: null,
    editorState: EditorState.createEmpty(),
  };

  constructor(props) {
    super(props);

    this.get_banner_image = React.createRef();
    this.get_face_image = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_single_item();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_single_item = async () => {
    const { token, userCode } = this.props.user;
    this.setState({ loading: true });
    const item = await req_single_eps_blogger(userCode, token);
    this.setState({ loading: false, item });
    if (item.Description !== null) {
      const contentBlock = htmlToDraft(item.Description);
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      this.setState({ editorState });
    }
    
    const copyWebUrl = CLIENT_URL + item.BlogType === "STUDENT" ? "/blog?id=" : "/blogslef?id=" + item.BlogUid;
    this.setState({ copyWebUrl });
    //console.log(item)
  };

  api_modify_item = async (item) => {
    item.condition = "BASE";

    const result = await req_edit_eps_blogger(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      // console.log(result)
      message.success(result.message);
      this.api_single_item();
    } else {
      message.error(result.message);
    }
  };

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  getfaceFile = (type, key, url) => {
    let baseUrl = API_BASE;

    if (url === "") {
      if (type === "STUDENT") {
        baseUrl = API_BASE + "/Upload/bobo.jpg";
      } else {
        baseUrl =
          "https://rm.tut.edu.tw/ab/DisplaySmallPicture.ashx?p=Pic/" +
          key +
          ".jpg&w=180&h=200";
      }
    } else {
      baseUrl = API_BASE + url;
    }
    //console.log(baseUrl)
    return baseUrl;
  };

  handleChange(event) {
    const { item } = this.state;
    //console.log(event)
    Object.keys(item).forEach((propertyName) => {
      if (event.target.id === "agreePrivacy" && event.target.value !== null) {
        // Checkbox
        const agreePrivacy = event.target.checked;
        this.setState({ agreePrivacy });
      } else {
        if (event.target.id === propertyName && event.target.value !== null) {
          item[propertyName] = event.target.value.trim();
        }
      }
    });
    this.setState({ item });
  }

  handleSubmit(event) {
    event.preventDefault();
    const row = this.state.item;
    const bannerimage = this.get_banner_image.current.output_files();
    if (bannerimage.length > 0) {
      row.BannerPicFileUrl = bannerimage[0];
    }
    const faceimage = this.get_face_image.current.output_files();
    if (faceimage.length > 0) {
      row.FacePicFileUrl = faceimage[0];
    }
    row.Description = draftToHtml(
      convertToRaw(this.state.editorState.getCurrentContent())
    );
    // console.log(row)
    this.api_modify_item(row);
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  uploadImageCallBack = (file) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", DEFAULT_IMAGE_URL + "/api/Appendix/AddFile");
      //xhr.setRequestHeader('Authorization', 'Client-ID XXXXX');
      const data = new FormData();
      data.append("file", file);
      xhr.send(data);
      xhr.addEventListener("load", () => {
        const response = JSON.parse(xhr.responseText);
        //console.log('response', response)
        const url = response.url;
        resolve({ data: { link: DEFAULT_IMAGE_URL + url } });
      });
      xhr.addEventListener("error", () => {
        const error = JSON.parse(xhr.responseText);
        reject(error);
      });
    });
  };

  handleCopy = () => {
    message.info("複製網址成功");
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { editorState, copyWebUrl } = this.state;
    const {
      BlogUid,
      FacePicFileUrl,
      BannerPicFileUrl,
      BlogType,
      RecordStatus,
      DepartmentM,
      BloggerCode,
      BloggerName,
      Cellphone,
      Email,
      Strengths,
    } = this.state.item;
    const codeType = BlogType === "STUDENT" ? "學號" : "職號";
    const abilityType = BlogType === "STUDENT" ? "興趣" : "專長";
    const bannerUrl =
      BannerPicFileUrl === ""
        ? API_BASE + "/Upload/eportfolioBanner.png"
        : API_BASE + BannerPicFileUrl;
    const pngfileUrlPath = "/api/UploadFile/AddInsideMediaFile";
    const pngFile = [];
    const frontWebUrl = CLIENT_URL + BlogType === "STUDENT" ? "/blog?id=" : "/blogslef?id=" + BlogUid;

    //console.log(frontWebUrl)
    return (
      <div className="container">
        <form onSubmit={this.handleSubmit}>
          <div className="form-row">
            <div
              className="form-group col-md-2"
              style={{ textAlign: "center" }}
            >
              <span>橫幅圖片上傳</span>
              <PicturesBanner
                ref={this.get_banner_image}
                images_source={this.state.bannerPics}
                api_url="/api/AppendixLiveCase/AddFile"
              ></PicturesBanner>
              {this.state.deviceWidth > 1000 ? (
                <>
                  <a
                    className="btn btn-info btn-block btn-sm"
                    href="https://www.canva.com/join/ncm-xjg-wxs"
                    role="button"
                    target="_black"
                  >
                    線上繪圖工具
                  </a>
                  <a
                    className="btn btn-info btn-block btn-sm"
                    href="https://www.youtube.com/watch?v=_hzxC5FvqdA&ab_channel=PAPAYA%E9%9B%BB%E8%85%A6%E6%95%99%E5%AE%A4"
                    role="button"
                    target="_black"
                  >
                    繪圖軟體教學
                  </a>
                </>
              ) : (
                ""
              )}
            </div>
            <div
              className="form-group col-md-10"
              style={{ textAlign: "center" }}
            >
              <Image
                width={"100%"}
                height={this.state.deviceWidth > 1000 ? 200 : 100}
                src={bannerUrl}
              />
            </div>
          </div>
          <div className="form-row">
            <div
              className="form-group col-md-2"
              style={{ textAlign: "center" }}
            >
              {this.state.deviceWidth > 1000 ? (
                <>
                  <label>個人照</label>
                </>
              ) : (
                ""
              )}
              <Tooltip
                placement="topLeft"
                title="上傳新照後，請按右側藍色[修改]按鈕才會生效喔"
              >
                <Image
                  width={135}
                  height={160}
                  src={this.getfaceFile(BlogType, BloggerCode, FacePicFileUrl)}
                />
              </Tooltip>
              <PicturesFace
                ref={this.get_face_image}
                data_source={pngFile}
                api_url={pngfileUrlPath}
              ></PicturesFace>
            </div>
            <div className="form-group col-md-10">
              <label>個人資料</label>
              <Editor
                editorState={editorState}
                editorStyle={{
                  border: "1px solid gray",
                  minHeight: 125,
                  paddingLeft: 10,
                  backgroundColor: "LightYellow",
                }}
                onEditorStateChange={this.onEditorStateChange}
                localization={{
                  locale: "zh_tw",
                }}
                toolbar={{
                  image: {
                    urlEnabled: true,
                    uploadEnabled: true,
                    alignmentEnabled: true, // 是否顯示排列 相當於text-align
                    uploadCallback: this.uploadImageCallBack,
                    previewImage: true,
                    inputAccept: "image/*",
                    alt: {
                      present: false,
                      mandatory: false,
                      previewImage: true,
                    },
                  },
                }}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-10">
              <input
                type="text"
                className="form-control"
                id="Strengths"
                placeholder={abilityType}
                defaultValue={Strengths}
                style={{ backgroundColor: "LightYellow" }}
                onChange={this.handleChange}
              />
            </div>
            <div className="form-group col-md-2">
              <button type="submit" className="btn btn-primary btn-block">
                修改
              </button>
            </div>
          </div>
          <Collapse defaultActiveKey={["1"]}>
            <Panel header="基本資料" key="2">
              <div className="form-row">
                <div className="form-group col-md-2">
                  <label>狀態</label>
                  <input
                    type="text"
                    className="form-control"
                    id="RecordStatus"
                    value={RecordStatus}
                    readOnly
                  />
                </div>
                <div className="form-group col-md-4">
                  <label>單位</label>
                  <input
                    type="text"
                    className="form-control"
                    id="DepartmentM"
                    value={DepartmentM}
                    readOnly
                  />
                </div>
                <div className="form-group col-md-2">
                  <label>{codeType}</label>
                  <input
                    type="text"
                    className="form-control"
                    id="BloggerCode"
                    value={BloggerCode}
                    readOnly
                  />
                </div>
                <div className="form-group col-md-4">
                  <label>姓名</label>
                  <input
                    type="text"
                    className="form-control"
                    id="BloggerName"
                    value={BloggerName}
                    readOnly
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-5">
                  <input
                    type="text"
                    className="form-control"
                    id="Cellphone"
                    value={Cellphone}
                    readOnly
                  />
                </div>
                <div className="form-group col-md-7">
                  <input
                    type="text"
                    className="form-control"
                    id="Email"
                    value={Email}
                    readOnly
                  />
                </div>
              </div>
            </Panel>
          </Collapse>
          <p />
        </form>
        <div className="row">
          <div className="col-md-2" style={{ textAlign: "center" }}>
            <QRCode value={frontWebUrl} size={64} />
          </div>
          <div className="col-md-8">
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span className="input-group-text">個人網址</span>
              </div>
              <input
                value={copyWebUrl}
                readOnly
                type="text"
                className="form-control"
                aria-label="Amount (to the nearest dollar)"
              />
              <div className="input-group-append">
                <CopyToClipboard text={copyWebUrl} onCopy={this.handleCopy}>
                  <button className="form-control" style={{ color: "red" }}>
                    <i className="fa fa-copy"></i> 複製網址
                  </button>
                </CopyToClipboard>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <a
              className="btn btn-success btn-block"
              href={frontWebUrl}
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa fa-eye"></i> 前台預覽
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(BloggerInformation);
